import { useState, useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import LayersIcon from '@material-ui/icons/Layers';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';
import { useLayoutState } from "../../store/LayoutState";
import { useRecoilCallback, useRecoilValue } from "recoil";
import { layersVisibleState } from "../../store/LayersVisibleState";
import { headerVisibleState } from "../../store/HeaderVisibleState";
import {
  toggleWeatherVisibleWithID,
  weatherVisibleWithID, WX_SETTINGS
} from "../../store/WeatherContentsState";
import {
  mapContentsVisibleWithID,
  toggleMapContentsVisibleWithID
} from "../../store/MapContentsState";
import { getCustomerSettings } from "../../CustomerSettings";
import { routePointEditingState } from "../../store/RoutePointEditingState";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    zIndex: 2,
    right: 0,
    width: '100%',
    maxWidth: 200,
    backgroundColor: "rgba(238,238,238,.7)"
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  chk: {
    paddingTop: '0px',
    paddingBottom: '0px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  txt: {
    margin: "0px"
  }
}));


function ContentsListPanel() {
  const layersVisible = useRecoilValue(layersVisibleState);
  const headerVisible = useRecoilValue(headerVisibleState);
  const routePointEditing = useRecoilValue(routePointEditingState);
  const {isCrossOnly} = useLayoutState();
  const layerConfig = getCustomerSettings('layerConfig');
  const menuWeatherOrder = getCustomerSettings('menuWeatherOrder');
  const menuOtherOrder = getCustomerSettings('menuOtherOrder');
  const classes = useStyles();
  const [openWeather, setOpenWeather] = useState(true);
  const [openOther, setOpenOther] = useState(false);

  const handleWeatherClick = useCallback(() => {
    setOpenWeather(!openWeather);
  },[openWeather]);

  const handleOtherClick = useCallback(() => {
    setOpenOther(!openOther);
  }, [openOther]);

  const toggleContents = useRecoilCallback(({set}) => e => {
    const contentsId = e.currentTarget.dataset.contents;
    set(toggleMapContentsVisibleWithID(contentsId));
  });

  const toggleWeatherContents = useRecoilCallback(({set}) => e => {
    const contentsId = e.currentTarget.dataset.contents;
    set(toggleWeatherVisibleWithID(contentsId));
  });

  const positionTop = headerVisible ? 44 : 0;
  const crossOnlyHidden = {display: isCrossOnly ? 'none' : ''};

  const wxList = menuWeatherOrder.reduce((list, id) => {
    if (layerConfig[id]) {
      list.push(id);
    }
    return list;
  }, []);

  const otherList = menuOtherOrder.reduce((list, id) => {
    if (layerConfig[id]) {
      list.push(id);
    }
    return list;
  }, []);

  const hidden = !layersVisible || routePointEditing;

  return (
    <List
      component="nav"
      aria-labelledby="nested-list-subheader"
      className={classes.root}
      style={{top:positionTop}}
      hidden={hidden}
    >
      <ListItem button onClick={handleWeatherClick}>
        <ListItemIcon>
          <LayersIcon />
        </ListItemIcon>
        <ListItemText primary="Weather" />
        {openWeather ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openWeather} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {wxList.map(WX_ID => {
            return (
              (!isCrossOnly || WX_SETTINGS[WX_ID].crossSection === true)
              && <WxMenuItem key={WX_ID} id={WX_ID} name={layerConfig[WX_ID].name} onClick={toggleWeatherContents}/>
            )
          })}
        </List>
      </Collapse>
      <ListItem button onClick={handleOtherClick} style={crossOnlyHidden}>
        <ListItemIcon>
          <LayersIcon />
        </ListItemIcon>
        <ListItemText primary="Other" />
        {openOther ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={openOther} timeout="auto" unmountOnExit>
        <List component="div" disablePadding={true} style={crossOnlyHidden}>
          {otherList.map(MAP_ID => {
            return <OtherMenuItem key={MAP_ID} id={MAP_ID} name={layerConfig[MAP_ID].name} onClick={toggleContents}/>
          })}
        </List>
      </Collapse>
    </List>
  );
}

export  default ContentsListPanel;

function WxMenuItem({id, name, onClick}) {
  const checked = useRecoilValue(weatherVisibleWithID(id))
  const classes = useStyles();

  return (
    <ListItem button className={classes.nested} data-contents={id} onClick={onClick}>
      <ListItemIcon>
        <Checkbox
          className={classes.chk}
          color="primary"
          edge="start"
          checked={checked}
          tabIndex={-1}
          disableRipple
          inputProps={{ 'aria-labelledby': `chk_${id}`}}
          size='small'
        />
      </ListItemIcon>
      <ListItemText id={`chk_${id}`} primary={name} className={classes.txt}/>
    </ListItem>
  )
}

function OtherMenuItem({id, name, onClick}) {
  const checked = useRecoilValue(mapContentsVisibleWithID(id))
  const classes = useStyles();
  return (
    <ListItem button className={classes.nested} data-contents={id} onClick={onClick}>
      <ListItemIcon>
        <Checkbox
          className={classes.chk}
          edge="start"
          checked={checked}
          tabIndex={-1}
          disableRipple
          inputProps={{ 'aria-labelledby': `chk_${id}`}}
          size='small'
        />
      </ListItemIcon>
      <ListItemText id={`chk_${id}`} primary={name} className={classes.txt}/>
    </ListItem>
  );
}

